module.exports = __webpack_public_path__ + "media/images/landing/illust/bg-hero-v1-702addce566e219563ba6c2ea8ee66fd.svg";